import { DesignTokenOrigin, DesignTokenType, DesignTokenTypedData, ObjectMeta, } from "@supernova-studio/model";
import { z } from "zod";
//
// Read
//
export const DTODesignToken = DesignTokenTypedData.and(z.object({
    id: z.string(),
    persistentId: z.string(),
    designSystemVersionId: z.string(),
    meta: ObjectMeta,
    originStyle: DesignTokenOrigin.optional(),
    brandId: z.string(),
    collectionId: z.string().optional(),
    updatedAt: z.coerce.date(),
}));
export const DTODesignTokenListResponse = z.object({
    tokens: DTODesignToken.array(),
});
export const DTODesignTokenResponse = z.object({
    token: DTODesignToken,
});
export const DTODesignTokenGroup = z.object({
    id: z.string(),
    tokenType: DesignTokenType,
    persistentId: z.string(),
    isRoot: z.boolean(),
    brandId: z.string(),
    meta: ObjectMeta,
    childrenIds: z.string().array(),
});
export const DTODesignTokenGroupListResponse = z.object({
    groups: DTODesignTokenGroup.array(),
});
export const DTODesignTokenGroupResponse = z.object({
    group: DTODesignTokenGroup,
});
//
// Write
//
export const DTODesignTokenCreatePayload = DesignTokenTypedData.and(z.object({
    persistentId: z.string(),
    meta: ObjectMeta,
    brandId: z.string(),
    groupPersistentId: z.string().optional(),
}));
export const DTODesignTokenGroupCreatePayload = z.object({
    persistentId: z.string(),
    meta: ObjectMeta,
    brandId: z.string(),
    parentId: z.string().optional(),
    tokenType: DesignTokenType,
    childrenIds: z.string().array(),
});
